import { useEffect, useMemo, useState } from "react";

import TrackerHistoryModal from "./TrackerHistoryModal/TrackerHistoryModal";
import TrackerProductsModal from "./TrackerProductsModal/TrackerProductsModal";
import TrackerEventsModal from "./TrackerEventsModal/TrackerEventsModal";

//import "./UsuariosConectados.css";
import "./TrackerCompra.css";

const SOCKET_URL = "https://io.tracker.freshmart.pe";
const SITE_ID = "freshmart_web";

function formatearFecha(fecha) {
    if (!fecha) {
        return "-";
    }

    const date = new Date(fecha);

    if (Number.isNaN(date.getTime())) {
        return "-";
    }

    return new Intl.DateTimeFormat("es-PE", {
        dateStyle: "short",
        timeStyle: "medium",
    }).format(date);
}

function obtenerNombreUsuario(usuario) {
    if (!usuario.isAuthenticated) {
        return `Visitante ${usuario.visitorId?.substring(0, 8) || ""}`;
    }

    return (
        usuario.fullName ||
        [usuario.name, usuario.lastname].filter(Boolean).join(" ") ||
        "Usuario identificado"
    );
}

function obtenerPagina(usuario) {
    return (
        usuario.pageTitle ||
        usuario.currentPath ||
        usuario.currentUrl ||
        "Página desconocida"
    );
}

export default function UsuariosConectados() {
    //const [usuarios, setUsuarios] = useState([]);
    const [rows, setRows] = useState([]);
    const [socketConectado, setSocketConectado] = useState(false);
    const [cargando, setCargando] = useState(true);
    const [error, setError] = useState("");

    const [page, setPage] = useState(1);
      const [pagination, setPagination] = useState(null);
      const [loading, setLoading] = useState(false);
       
      const [selectedUser, setSelectedUser] = useState(null);
      const [historyUser, setHistoryUser] = useState(null);
      const [productsUser, setProductsUser] = useState(null);
      const [eventsUser, setEventsUser] = useState(null);

    const hoy = new Date();
    const fechaFormateada = hoy.toISOString().split('T')[0];
    const [filters, setFilters] = useState({
        conectados: "online",
        usuario: "",
        link: "any",
      });

    console.log("rows",rows,filters)

  function handleFilterChange(event) {
    const { name, value } = event.target;

    if (name === "conectados" && value==="any") {
      document.location.href="/tracker-compra"
    }

    setFilters((current) => ({
      ...current,
      [name]: value,
    }));
  }

  function handleFilterChangeTab(event) {
    const { name, value } = event.target;
    //setActiveTab(tab.id)
    setFilters((current) => ({
      ...current,
      ["link"]: value,
    }));
    setPage(1)

  }

  function clearFilters() {
    setFilters({
      platform: "",
      device: "",
      link: "",
      usuario: "",
      createdAt: "",
      userId: "",
    });
  }

    const getUserName = (user) => {
            if (!user) {
                return "";
            }

            const fullName = `${user.name ?? ""} ${
                user.lastname ?? ""
            }`.trim();

            return fullName || user.email || "Usuario";
        };

    useEffect(() => {
        if (typeof window.io !== "function") {
            setError("No se cargó la librería Socket.IO.");
            setCargando(false);

            return undefined;
        }

        const socket = window.io(SOCKET_URL, {
            transports: ["websocket", "polling"],
            reconnection: true,
            reconnectionAttempts: Infinity,
            reconnectionDelay: 1000,
            reconnectionDelayMax: 10000,
            timeout: 20000,
        });

        const suscribirseAlDashboard = () => {
            socket.emit(
                "dashboard:subscribe",
                {
                    siteId: SITE_ID,
                },
                (respuesta) => {
                    if (!respuesta?.success) {
                        setError(
                            respuesta?.message ||
                                "No se pudieron obtener los usuarios conectados."
                        );

                        setCargando(false);
                        return;
                    }

                    setRows(respuesta.users ?? []);
                    setError("");
                    setCargando(false);
                }
            );
        };

        socket.on("connect", () => {
            setSocketConectado(true);
            setError("");

            suscribirseAlDashboard();
        });

        socket.on("active-users:update", (respuesta) => {
            setRows(respuesta?.users ?? []);
            setCargando(false);
        });

        socket.on("disconnect", () => {
            setSocketConectado(false);
        });

        socket.on("connect_error", (socketError) => {
            setSocketConectado(false);
            setCargando(false);

            setError(
                socketError?.message ||
                    "No se pudo conectar con el servidor Socket.IO."
            );
        });

        return () => {
            socket.off("connect");
            socket.off("active-users:update");
            socket.off("disconnect");
            socket.off("connect_error");

            socket.disconnect();
        };
    }, []);

    const usuariosIdentificados = useMemo(() => {
        return rows.filter((usuario) => usuario.isAuthenticated);
    }, [rows]);

    const visitantes = useMemo(() => {
        return rows.filter((usuario) => !usuario.isAuthenticated);
    }, [rows]);

  const filteredRows = useMemo(() => {
    const usuarioBuscado = filters.usuario.trim().toLowerCase();
    const linkBuscado =
      filters.link === "any" ? "" : filters.link.trim().toLowerCase();

    return rows.filter((row) => {
      // Filtro de conectado
      const cumpleConectado =
        filters.conectados === "online" ||
        (filters.conectados === "connected" &&
          Boolean(row.connected || row.conectado)) ||
        (filters.conectados === "disconnected" &&
          !Boolean(row.connected || row.conectado));

      // Filtro por usuario
      const nombreCompleto = [
        row.name,
        row.lastname,
        row.email,
      ]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();

      const cumpleUsuario =
        usuarioBuscado === "" ||
        nombreCompleto.includes(usuarioBuscado);

      // Equivalente a: link LIKE '%valor%'
      const cumpleLink =
        linkBuscado === "" ||
        String(row.currentUrl ?? "")
          .toLowerCase()
          .includes(linkBuscado);

      return cumpleConectado && cumpleUsuario && cumpleLink;
    });
  }, [rows, filters]);


  console.log(filteredRows)

    const openHistory = (user) => {
        setSelectedUser(user);
    };

    const closeHistory = () => {
        setSelectedUser(null);
    };

    function formatDate(dateValue) {
        if (!dateValue) {
            return "-";
        }

        const normalizedDate = String(dateValue).replace(" ", "T");
        const date = new Date(normalizedDate);

        if (Number.isNaN(date.getTime())) {
            return dateValue;
        }

        return new Intl.DateTimeFormat("es-PE", {
            dateStyle: "medium",
            timeStyle: "medium",
        }).format(date);
    }


  return (
    <main className="tracker-container">
      <h1 className="tracker-title">Usuarios en linea</h1>

      <section className="tracker-filters">

        <div className="tracker-field">
          <label htmlFor="conectados">Usuarios Conectados</label>
          <select
            id="conectados"
            name="conectados"
            value={filters.conectados}
            onChange={handleFilterChange}
          >
            <option value="any">Todos</option>
            <option value="online">Conectados/Online</option>
          </select>
        </div>

        <div className="tracker-field">
          <label htmlFor="link">Usuario</label>
          <input
            id="usuario"
            name="usuario"
            type="text"
            placeholder="Buscar Nombre, Apellido, Correo"
            value={filters.usuario}
            onChange={handleFilterChange}
          />
        </div>


        <div className="tracker-field">
          <label htmlFor="link">Pag. Compra</label>
          <select
            id="link"
            name="link"
            value={filters.link}
            onChange={handleFilterChangeTab}
          >
            <option value="any">Todos</option>
            <option value="carrito">Pag. Carrito</option>
            <option value="despacho">Pag. Despacho</option>
            <option value="payment">Pag. Pagos</option>
            <option value="confirmacion">Pag. Confirmación</option>
          </select>          

        </div>

        <div className="tracker-actions">
          <button type="button" className="btn-secondary" onClick={clearFilters}>
            Limpiar
          </button>
        </div>
      </section>

      {loading ? (
        <div className="tracker-empty">Cargando...</div>
      ) : filteredRows.length === 0 ? (
        <div className="tracker-empty">No hay resultados</div>
      ) : (
        <section className="tracker-table-wrap">
          <table className="tracker-table">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Email</th>
                <th>Link</th>
                <th>Conectado desde</th>
                <th>Ver Historial</th>
                <th>Eventos</th>
                <th>Carrito Actual</th>
              </tr>
            </thead>

            <tbody>
              {filteredRows.map((row) => (
                <tr key={row.visitorId}>
                  <td data-label="Nombre">
                    {row.name || "--"}
                  </td>
                  <td data-label="Email">{row.email || "--"}</td>
                  
                  <td data-label="Link" className="tracker-link">
                    {row.currentUrl || ""}
                  </td>
                  <td data-label="Fecha">
                                <time
                                    dateTime={String(
                                        row.connectedAt
                                    ).replace(" ", "T")}
                                >
                                    {formatDate(row.connectedAt)}
                                </time>

                  </td>
                  <td data-label="Historial"><button onClick={() => openHistory(row)}  className="btn-action" ><span className="fa fa-eye js-show-pass"></span></button></td>
                  <td data-label="Historial"><button onClick={() => setEventsUser(row)}  className="btn-action" ><span className="fa fa-eye js-show-pass"></span></button></td>
                  <td data-label="Carrito Actual"><button onClick={() => setProductsUser(row) }

className="btn-action" ><img class="ico-carrito" src="https://freshmart.pe/newicons/car.svg?1"/></button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      )}

      <section className="tracker-pagination">
        <div className="tracker-pagination-info">
          {pagination
            ? `Página ${pagination.page} de ${pagination.totalPages} - Total: ${pagination.total}`
            : ""}
        </div>

        <div className="tracker-pagination-buttons">
          <button
            type="button"
            className="btn-secondary"
            disabled={page <= 1}
            onClick={() => setPage((current) => current - 1)}
          >
            Anterior
          </button>

          <button
            type="button"
            className="btn-primary"
            disabled={pagination && page >= pagination.totalPages}
            onClick={() => setPage((current) => current + 1)}
          >
            Siguiente
          </button>
        </div>
      </section>

            <TrackerHistoryModal
                open={Boolean(selectedUser)}
                token={selectedUser?.visitorId}
                userName={
                    selectedUser
                        ? `${selectedUser.name ?? ""} ${
                              selectedUser.lastname ?? ""
                          }`.trim()
                        : ""
                }
                onClose={closeHistory}
            />

            <TrackerProductsModal
                open={Boolean(productsUser)}
                token={productsUser?.visitorId}
                userName={
                    productsUser
                        ? `${productsUser.name ?? ""} ${
                              productsUser.lastname ?? ""
                          }`.trim()
                        : ""
                }
                onClose={() => setProductsUser(null)}
            />


            <TrackerEventsModal
                open={Boolean(eventsUser)}
                fecha={filters.createdAt}
                token={eventsUser?.visitorId}
                userName={getUserName(eventsUser)}
                onClose={() => setEventsUser(null)}
            />

    </main>
  );

}